import { ValidationError } from '@/views/helpers/validation-result';
import ValidationMessages from '@/views/helpers/validation-messages';
import Compositions from '@/views/helpers/compositions';
import Regex from '@/shared/constants/regex';

export default {
  validateDisabilityRateFormat (disabilityRate) {
    if (disabilityRate == null || disabilityRate === '') return;

    if (!Regex.Percentage.test(disabilityRate)) {
      return new ValidationError({
        message: ValidationMessages.ReportOfSickness.DisabilityRate.FORMAT_INVALID,
        attribute: 'disabilityRate'
      });
    }
  },

  validateDisabilityRateMaximum (disabilityRate) {
    if (disabilityRate == null || disabilityRate === '') return;

    let input = disabilityRate.replace(',', '.');
    let inputFloat = parseFloat(input);
    if (inputFloat > 100.00) {
      return new ValidationError({
        message: ValidationMessages.ReportOfSickness.DisabilityRate.VALUE_TOO_HIGH,
        attribute: 'disabilityRate'
      });
    }
  },

  validateDisabilityRateMinimum (disabilityRate) {
    if (disabilityRate == null || disabilityRate === '') return;

    let input = disabilityRate.replace(',', '.');
    let inputFloat = parseFloat(input);

    if (inputFloat < 1.00) {
      return new ValidationError({
        message: ValidationMessages.ReportOfSickness.DisabilityRate.VALUE_TOO_LOW,
        attribute: 'disabilityRate'
      });
    }
  },

  validatePreviousDisabilityRateIsNotTheSame (reportOfSickness, disabilityRate) {
    if (reportOfSickness != null) {
      if (Compositions.getLatestDisabilityRateFromReportOfSickness(reportOfSickness) === disabilityRate) {
        return new ValidationError({
          message: ValidationMessages.ReportOfSickness.DisabilityRate.VALUE_EQUAL_TO_PREVIOUS,
          attribute: 'disabilityRate'
        });
      }
    }
  }
};
